<h4 class="section-title">Documentation Links</h4>
<table mat-table #docTable="matTable" class="dense-table mat-elevation-z0"
  [dataSource]="documentationLinks().controls">
  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef>Display Name</th>
    <td mat-cell *matCellDef="let row" [formGroup]="row">
      <mat-form-field class="mat-form-field-no-margin" appearance="outline" floatLabel="always">
        <input matInput class="cell-input" type="text" formControlName="title" placeholder="Enter display name" aria-label="Documentation display name" />
        @if ((row.controls.title.touched || row.controls.title.dirty) && row.controls.title.hasError('titleRequired')) {
          <mat-error>Display Name is required.</mat-error>
        }
        @if ((row.controls.title.touched || row.controls.title.dirty) && row.controls.title.hasError('maxlength')) {
          <mat-error>Display Name must be 200 characters or less.</mat-error>
        }
      </mat-form-field>
    </td>
  </ng-container>

  <ng-container matColumnDef="url">
    <th mat-header-cell *matHeaderCellDef>Link</th>
    <td mat-cell *matCellDef="let row" [formGroup]="row">
      <mat-form-field class="mat-form-field-no-margin" appearance="outline" floatLabel="always">
        <input matInput class="cell-input" type="text" placeholder="https://..." formControlName="url" aria-label="Documentation link" />
        @if ((row.controls.url.touched || row.controls.url.dirty) && row.controls.url.hasError('urlRequired')) {
          <mat-error>Link is required.</mat-error>
        }
        @if ((row.controls.url.touched || row.controls.url.dirty) && row.controls.url.hasError('url')) {
          <mat-error>Enter a valid URL.</mat-error>
        }
      </mat-form-field>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef class="icon-col"></th>
    <td mat-cell *matCellDef="let row; let i = index" class="text-right actions-cell">
      <button type="button" class="icon-btn icon-btn--ms danger" (click)="removeLink(i)">
        <span class="material-symbols-outlined">delete</span>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr class="mat-row" *ngIf="documentationLinks().length === 0">
    <td class="mat-cell" colspan="3">No documentation links yet.</td>
  </tr>
</table>

<div class="link-row">
  <button type="button" class="link-btn" (click)="addLink()">
    + add documentation link
  </button>
</div>
